export default __webpack_public_path__ + "static/media/1.7f040e92.svg";